export class RestoreDestinationTagLimits {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subject",
            "baseName": "subject",
            "type": "RestoreAccountTagSubject",
            "format": ""
        },
        {
            "name": "operator",
            "baseName": "operator",
            "type": "RestoreAccountTagOperator",
            "format": ""
        },
        {
            "name": "values",
            "baseName": "values",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDestinationTagLimits.attributeTypeMap;
    }
    constructor() {
    }
}
